module.exports = __webpack_public_path__ + "img/kesehatan.fae45659.svg";